import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { InputSelect, InputText } from "../../../../components/InputFields";
import { closeModal } from "../../../../data/slices/modals";
import { Tag, message } from "antd";
import { Checkbox } from "antd";
import {
  createGroup,
  getResources,
  getVerbs,
  updateGroup
} from "../../../../data/slices/userGroup";
import { Button } from "antd";
import { getUsers } from "../../../../data/slices/memberSlice";
import { getResourcesForCreateRole } from "../../../../data/slices/resourcesSlice";
import { useTranslation } from "react-i18next";

function UserGroupForm({ isEdit, id, group }) {
  const dispatch = useDispatch();
  const { t } = useTranslation("role");

  const { data: actions } = useSelector((state) => state.usersGroup.verbs);
  const { data: resources } = useSelector((state) => state.usersGroup.resources);
  const { members } = useSelector((state) => state.member);
  const { resources_verbs } = useSelector((state) => state.resources_verbs);
  const [validVerbs, setValidVerbs] = useState([]);

  let rule = {
    verbs: [],
    resource: ""
  };

  const formik = useFormik({
    initialValues: {
      name: isEdit ? group?.displayName : "",
      description: isEdit ? group?.description : "",
      rules: isEdit
        ? group.rules.map((item, index) => {
            return {
              verbs: item?.verbs,
              resource: item?.resource
            };
          })
        : [rule],

      users: []
    },
    validationSchema: Yup.object().shape({
      name: Yup.string()
        .min(2, t("role-11"))
        .max(70, t("role-12"))
        .matches(/^[a-z0-9]([-a-z0-9]*[a-z0-9])?(\.[a-z0-9]([-a-z0-9]*[a-z0-9])?)*$/, {
          message: t("role-13"),
          excludeEmptyString: true // Exclude error message when the field is empty
        })
        .required(t("role-14")),
      description: Yup.string()
    }),
    onSubmit: (values) => {
      if (!isEdit) {
        dispatch(createGroup(values))
          .unwrap()
          .then((res) => {
            message.success(t("role-15"));
            dispatch(closeModal("user-group"));
          })
          .catch((err) => {
            message.error(err.message || t("role-16"));
          });
      } else {
        dispatch(updateGroup({ values, id }))
          .unwrap()
          .then(() => {
            message.success(t("role-17"));
            dispatch(closeModal("user-group"));
          })
          .catch((err) => {
            message.error(err.message || t("role-16"));
          });
      }
    }
  });

  useEffect(() => {
    dispatch(getVerbs({}));
    dispatch(getResources({}));
    dispatch(getUsers({ query: "" }));
    dispatch(getResourcesForCreateRole());
  }, []);

  const onUpdateAction = (values) => {
    if (values?.[0] === "*") {
      return actions?.verbs;
    } else {
      return values;
    }
  };

  const onUpdateResources = (values) => {
    if (values?.[0] === "*") {
      return resources?.resources;
    } else {
      return values;
    }
  };
  function addElementAtIndex(arr, index, element) {
    arr.splice(index, 0, element);
    return arr;
  }

  function removeElementAtIndex(arr, index) {
    const newArr = [...arr];
    newArr.splice(index, 1);
    return newArr;
  }

  useEffect(() => {
    if (isEdit) {
      setValidVerbs(group.rules.map((item) => item?.resource));
    }
  }, [isEdit]);

  //validateVerbs return the actions based on the selected resource
  const validateVerbs = (index) => {
    if (validVerbs?.length === 0 || !validVerbs[index]) {
      return [];
    }
    return resources_verbs?.[`${validVerbs[index]}`];
  };
  // check the valid actions for each selected resource (saved in the state)
  const updateStateAtIndex = (index, newValue) => {
    if (newValue) {
      setValidVerbs((prevState) => {
        const newArray = [...prevState];
        newArray[index] = newValue;
        return newArray;
      });
    } else {
      removeFromStateAtIndex(index);
    }
  };
  // Function to remove an item from the array by index
  const removeFromStateAtIndex = (index) => {
    setValidVerbs((prevState) => {
      const newArray = [...prevState];
      newArray.splice(index, 1);
      return newArray;
    });
  };

  const handleUsersOnEdit = () => {
    if (isEdit) {
      let cleanUsers = members?.filter((el) => {
        if (el?.roles) {
          return !el.roles.some((role) => role?.name === group?.name);
        }
        return true;
      });
      return cleanUsers;
    }
  };

  const handleExistingUsers = () => {
    if (isEdit) {
      let cleanUsers = members?.filter((el) => {
        if (el?.roles) {
          return el.roles.some((role) => role?.name === group?.name);
        }
        return true;
      });
      return cleanUsers;
    }
  };
  return (
    <div className="form_user user_group_modal">
      <form action="" onSubmit={formik.handleSubmit}>
        <InputText
          formik={formik}
          field={{
            name: "name",
            type: "string",
            placeholder: t("role-18"),
            label: t("role-19")
          }}
        />

        {formik.values.rules?.map((el, index) => (
          <div className="dynamic_fields" key={index}>
            <div className="dynamic-fields-header">
              <label htmlFor="Actions">{t("role-23")}</label>

              <div className="add_remove_btn">
                <Button
                  type="primary"
                  onClick={() =>
                    formik.setFieldValue(
                      "rules",
                      addElementAtIndex(formik.values.rules, index + 1, rule)
                    )
                  }
                >
                  +
                </Button>
                {formik.values.rules?.length > 1 && (
                  <Button
                    type="primary"
                    danger
                    onClick={() => {
                      formik.setFieldValue(
                        "rules",
                        removeElementAtIndex(formik.values.rules, index)
                      );
                      removeFromStateAtIndex(index);
                    }}
                  >
                    -
                  </Button>
                )}
              </div>
            </div>
            <div className="verbs">
              <label htmlFor="Actions" className="label">
                {t("role-24")}
              </label>

              <Checkbox.Group
                options={resources?.resources}
                onChange={(e) => {
                  formik.setFieldValue(`rules[${index}].resource`, e[0]);

                  updateStateAtIndex(index, e[0]);
                }}
                value={onUpdateResources(formik.values.rules[index]?.resource)}
              />
            </div>
            <div className="verbs">
              <label htmlFor="Actions" className="label">
                {t("role-25")}
              </label>
              <Checkbox.Group
                options={validateVerbs(index) || [{ value: "" }]}
                onChange={(e) => {
                  formik.setFieldValue(`rules[${index}].verbs`, e);
                }}
                value={onUpdateAction(formik.values?.rules[index]?.verbs)}
              />
            </div>
          </div>
        ))}
        <InputSelect
          label={t("role-29")}
          formik={formik}
          options={
            isEdit
              ? handleUsersOnEdit()?.map((item) => ({
                  value: item?.username,
                  label: item?.username
                }))
              : members?.map((item) => ({
                  value: item?.username,
                  label: item?.username
                }))
          }
          defaultOptions={[]}
          onChange={(e) => {
            formik.setFieldValue(`users`, e);
          }}
          className="select"
          value={formik.values?.users}
        />
        {handleExistingUsers() && isEdit && (
          <>
            {t("role-26")} :{" "}
            {handleExistingUsers()?.map((el, index) => (
              <Tag key={index}>{el?.fullName}</Tag>
            ))}
          </>
        )}
        <div className="action_form">
          <button
            type="reset"
            onClick={() => {
              dispatch(closeModal("user-group"));
              formik.setValues({});
            }}
            className="dashboard-cancel-btn"
          >
            {t("role-27")}
          </button>
          <button type="submit" className="dashboard-confirm-btn">
            {t("role-28")}
          </button>
        </div>
      </form>
    </div>
  );
}

export default UserGroupForm;
